module.exports = __webpack_public_path__ + "static/img/welfare.3e95471.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/my-coin/welfare.png
// module id = w6vQ
// module chunks = 1